module.exports = __webpack_public_path__ + "static/img/qy.2dc194f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qy.jpg
// module id = Hx2Q
// module chunks = 1